import { Button, Collapse, Flex, Typography, Image } from "antd";
import { useState } from "react";
import userCheck from "../assets/images/user-check.svg";

const { Panel } = Collapse;
const { Text, Paragraph, Title } = Typography;

export default function FAQAccordion({ faqList = [] }) {
  const [activeKey, setActiveKey] = useState([faqList?.[0]?.id]);

  const renderChildren = (children = []) => {
    return children.map((child, index) => {
      if (child.type === "link") {
        return (
          <a
            key={index}
            href={child.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-medium"
          >
            {renderChildren(child.children)}
          </a>
        );
      }

      if (child.type === "text") {
        return child.text;
      }

      return null;
    });
  };

  const renderFAQAnswer = (answer) => {
    if (!Array.isArray(answer)) {
      return null;
    }

    return answer.map((block, index) => {
      if (block.type === "paragraph") {
        const hasContent = block.children?.some(
          (child) => child.text?.trim() || child.type === "link"
        );

        if (!hasContent) {
          return null;
        }

        return (
          <p key={index} className="font-normal mb-2">
            {renderChildren(block.children)}
          </p>
        );
      }

      if (block.type === "list") {
        const ListTag = block.format === "ordered" ? "ol" : "ul";

        return (
          <ListTag
            key={index}
            className={
              block.format === "ordered"
                ? "list-decimal pl-5 mb-3"
                : "list-disc pl-5 mb-3"
            }
          >
            {block.children?.map((item, itemIndex) => (
              <li key={itemIndex} className="font-normal mb-1">
                {renderChildren(item.children)}
              </li>
            ))}
          </ListTag>
        );
      }

      return null;
    });
  };

  return (
    <div className="grid grid-cols-1 gap-8">
      {/* LEFT SIDE FAQ */}
      <div className="md:col-span-2">
        <Title className="!font-medium !text-danger  !mb-0" level={2}>
          <span className="text-primary">Frequently Asked </span> Questions
        </Title>
        {/* <Paragraph className="!mb-0">
          Culture, nature, thrills, and record-breaking experiences
        </Paragraph> */}

        <Collapse
          accordion
          activeKey={activeKey}
          onChange={(key) => setActiveKey(key)}
          expandIconPosition="end"
          className="
            !border-0
            !bg-transparent
            [&_.ant-collapse-item]:!border-0 
            [&_.ant-collapse-item]:!border-b [&_.ant-collapse-item]:!border-[#CCE1F9]
            [&_.ant-collapse-item:last-child]:!border-b-0
            [&_.ant-collapse-header]:!bg-transparent 
            [&_.ant-collapse-header]:!border-0 
            [&_.ant-collapse-header]:!px-0
            [&_.ant-collapse-content]:!border-0
            [&_.ant-collapse-content-box]:!border-0 [&_.ant-collapse-content-box]:!px-0
          "
        >
          {faqList.map((faq) => (
            <Panel
              header={
                <span className="text-base font-normal text-primary">
                  {faq.question}
                </span>
              }
              key={faq.id}
              className="!border-0 py-4"
            >
              {renderFAQAnswer(faq.answer)}
            </Panel>
          ))}
        </Collapse>

        {/* <Flex justify="center" align="center" className="mt-10">
          <Button
            size="middle"
            type="default"
            className="font-semibold w-60 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-danger rounded-lg"
          >
            See More
          </Button>
        </Flex> */}
      </div>

      {/* RIGHT SIDE BOX */}
      {/* <div className="border border-[#CCE1F9] h-fit">
        <h3 className="px-6 py-8 text-xl font-normal text-primary border-b border-[#CCE1F9]">
          Why Choose Efficient Tourism ?
        </h3>
        <ul className="px-6 py-8">
          <li>
            <Flex gap={10} className="text-primary font-normal text-lg">
              <Image src={userCheck} />
              Experienced
            </Flex>
            <Paragraph className="font-normal pt-4 pb-6">
              An experienced Rajasthan tour operator, with a team of travel
              enthusiasts ensuring well-designed packages.
            </Paragraph>
          </li>

          <li>
            <Flex gap={10} className="text-primary font-normal text-lg">
              <Image src={userCheck} />
              Certified
            </Flex>
            <Paragraph className="font-normal pt-4 pb-6">
              Certified by IATA, TAAI, IMF & MOT.
            </Paragraph>
          </li>

          <li>
            <Flex gap={10} className="text-primary font-normal text-lg">
              <Image src={userCheck} />
              Happy Customers
            </Flex>
            <Paragraph className="font-normal pt-4 pb-6">
              Numerous accolades for excellent service.
            </Paragraph>
          </li>

          <li>
            <Flex gap={10} className="text-primary font-normal text-lg">
              <Image src={userCheck} />
              Local Offices
            </Flex>
            <Paragraph className="font-normal pt-4 pb-6">
              Numerous local offices across India for better support.
            </Paragraph>
          </li>
        </ul>
      </div> */}
    </div>
  );
}
